import "./Dashboard.02d5a840.js";
import "./Dashboard.f0b09dd4.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6f40"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6f40"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eQRwW", function(module, exports) {

var $k77ZD = parcelRequire("k77ZD");

var $lK1er = parcelRequire("lK1er");

var $h8sKa = parcelRequire("h8sKa");

var $3CfG2 = parcelRequire("3CfG2");
parcelRequire("dBwuy");

var $dmrHV = parcelRequire("dmrHV");

var $iS8eH = parcelRequire("iS8eH");

var $eZeDV = parcelRequire("eZeDV");

var $6lxfX = parcelRequire("6lxfX");

var $iOF3G = parcelRequire("iOF3G");

var $i0TKe = parcelRequire("i0TKe");

var $graZq = parcelRequire("graZq");

var $64xtA = parcelRequire("64xtA");
const $acff720614031e27$var$t = (0, $iS8eH.default).global.t;
window.isScanatLoaded = false;
(0, $64xtA.default)();
const $acff720614031e27$var$initClickHandler = ()=>{
    let clickTimer = null;
    const clickDelay = 300;
    document.addEventListener('click', (e)=>{
        if (e.button !== 0) return;
        if (clickTimer) return;
        clickTimer = setTimeout(()=>{
            clickTimer = null;
        }, clickDelay);
    }, true);
    document.addEventListener('dblclick', (e)=>{
        clearTimeout(clickTimer);
        clickTimer = null;
    }, true);
};
// 引入iconfont 
const $acff720614031e27$var$link = document.createElement('link');
$acff720614031e27$var$link.rel = 'stylesheet';
$acff720614031e27$var$link.href = '//at.alicdn.com/t/c/font_4900802_fpa1z8trh4a.css';
document.head.appendChild($acff720614031e27$var$link);
const $acff720614031e27$var$handleDomContentLoad = async ()=>{
    // initClickHandler()
    // if(document.documentElement.lang) {
    //   updatePageLanguage()
    //   const observer = new MutationObserver((mutationsList) => {
    //     mutationsList.forEach(mutation => {
    //       if (mutation.type === 'attributes') {
    //         Array.from(mutation.target.attributes).forEach(attr => {
    //           if (attr.value.startsWith('$lang(') && attr.name === mutation.attributeName) {
    //             updatePageLanguage()
    //             throw new Error('break loop')
    //           }
    //         })
    //       }
    //     })
    //   })
    //   observer.observe(document.documentElement, {
    //     attributes: true,
    //     subtree: true,
    //     attributeOldValue: true,
    //   })
    // }
    let customerRes = null;
    try {
        customerRes = (await (0, $h8sKa.request)('portal/customers', null, true, 'GET'))?.data ?? null;
        sessionStorage.setItem('customer', JSON.stringify(customerRes));
        (0, $iOF3G.initCustomerStore)(customerRes);
    } catch (error) {
        console.error(error?.message);
    }
    window.isScanatLoaded = true;
    // We need get user info first
    let res = {
        data: null
    };
    let userInfo = {};
    const isNoAuthPage = location.pathname.includes('login.html') || location.pathname.includes('intage.html') || location.search.includes('&intage');
    // do not need to get user info on login page
    if (!isNoAuthPage) {
        const authRes = await (0, $h8sKa.request)('auth/currentUserInfo', null, true, 'POST', true);
        if (authRes?.status === 200) {
            res = await authRes.json();
            userInfo = res.data;
            (0, $iOF3G.initUserStore)(res.data);
            (0, $dmrHV.setUser)({
                id: res.data.userId,
                email: res.data.email
            });
        } else {
            document.querySelector('.login-area')?.classList.remove('d-none');
            document.querySelector('.avatar-area')?.classList.add('d-none');
            sessionStorage.removeItem('SCANAT_USER_INFO');
        }
    }
    // set avatar
    const customerNameEl = document.querySelector('.customer-name');
    const customerIdEl = document.querySelector('.customer-id');
    const updateCustomerName = ()=>{
        if (customerNameEl && customerIdEl) {
            const loginArea = document.querySelector('.login-area');
            try {
                const avatarArea = document.querySelector('.avatar-area');
                const userInfo = JSON.parse(sessionStorage.getItem('SCANAT_USER_INFO') || '{}');
                if (userInfo?.surname && userInfo?.name) {
                    customerNameEl.textContent = `${userInfo.surname} ${userInfo.name}`;
                    const avatarEl = document.querySelector('#navbarDropdownMenuAvatar img');
                    if (avatarEl && avatarEl.parentNode) {
                        const circleEl = document.createElement('div');
                        circleEl.className = 'user-circle';
                        circleEl.style.background = (0, $h8sKa.getUserColor)(userInfo);
                        circleEl.innerHTML = `<span>${(0, $h8sKa.getUserName)(userInfo)}</span>`;
                        avatarEl.parentNode.replaceChild(circleEl, avatarEl);
                    }
                } else {
                    const currentLang = localStorage.getItem('SCANAT_LANG') || (0, (/*@__PURE__*/$parcel$interopDefault($eZeDV))).get('language') || 'ja';
                    (0, $iS8eH.default).global.locale.value = currentLang;
                    customerNameEl.textContent = (0, $iS8eH.default).global.t('landing.unnamed');
                }
                customerIdEl.textContent = (0, $h8sKa.formatEmailDisplay)(userInfo.email || '');
            } catch (error) {
                console.error('error on update customer name', error);
            }
        }
    };
    if (customerNameEl && customerIdEl) {
        const loginArea = document.querySelector('.login-area');
        try {
            const avatarArea = document.querySelector('.avatar-area');
            if (res?.code === 200) {
                // save user info
                sessionStorage.setItem('SCANAT_USER_INFO', JSON.stringify(res.data));
                if (res.data?.surname && res.data?.name) {
                    customerNameEl.textContent = `${res.data.surname} ${res.data.name}`;
                    const avatarEl = document.querySelector('#navbarDropdownMenuAvatar img');
                    if (avatarEl && avatarEl.parentNode) {
                        const circleEl = document.createElement('div');
                        circleEl.className = 'user-circle';
                        circleEl.style.background = (0, $h8sKa.getUserColor)(userInfo);
                        circleEl.innerHTML = `<span>${(0, $h8sKa.getUserName)(userInfo)}</span>`;
                        avatarEl.parentNode.replaceChild(circleEl, avatarEl);
                    }
                } else customerNameEl.textContent = $acff720614031e27$var$t('landing.unnamed');
                customerIdEl.textContent = (0, $h8sKa.formatEmailDisplay)(res.data.email);
                avatarArea?.classList.remove('d-none');
                loginArea?.classList.add('d-none');
                console.log('set avatar');
            }
        } catch (error) {
            console.error('error on set avatar', error);
        }
        window.addEventListener('languageChanged', ()=>{
            updateCustomerName();
        });
    }
    const navWebEl = document.querySelector('.navbar-web');
    const navDashboardEl = document.querySelector('.navbar-dashboard');
    if (navWebEl) navWebEl.onclick = async ()=>{
        const accessResult = await (0, $h8sKa.checkCustomerAccess)();
        console.log(accessResult, 'accessResult');
        if (!accessResult.canAccess) {
            if (typeof accessResult.callback === 'function') {
                accessResult.callback();
                return;
            }
            new (0, $6lxfX.default)().toast('warning', accessResult.message, false, {
                closeable: accessResult.closeable,
                autohide: !accessResult.closeable
            });
            return;
        }
        window.location.href = '/models.html';
    };
    if (navDashboardEl) navDashboardEl.onclick = async ()=>{
        const { isNoPortalAdmin: isNoPortalAdmin } = await (0, $h8sKa.checkAccountActive)();
        if (customerRes?.customerId && isNoPortalAdmin) {
            new (0, $6lxfX.default)().toast('warning', $acff720614031e27$var$t('error.contactManage'));
            return;
        }
        window.location.href = '/admin.html';
    };
    if (location.pathname.includes('models.html')) {
        const main = document.querySelector('main');
        const checkModelsPagePermission = async ()=>{
            const pinia = (0, $i0TKe.getActivePinia)();
            if (pinia && (0, $graZq.useUploadStore)(pinia).isUploading) return;
            const accessResult = await (0, $h8sKa.checkCustomerAccess)();
            if (!accessResult.canAccess && !(0, $h8sKa.isModelKey)()) {
                main.classList.add('d-none');
                if (typeof accessResult.callback === 'function') {
                    accessResult.callback();
                    return;
                }
                new (0, $6lxfX.default)().toast('warning', accessResult.message, false, {
                    closeable: accessResult.closeable,
                    autohide: !accessResult.closeable,
                    above: true,
                    callback: ()=>{
                        window.location.href = '/landing.html';
                    }
                });
            } else main.classList.remove('d-none');
        };
        main.addEventListener('click', checkModelsPagePermission, true);
        const iframe = document.querySelector('.model-frame');
        if (iframe) iframe.onload = function() {
            iframe.contentWindow.document.addEventListener('click', checkModelsPagePermission, true);
        };
        const observer = new MutationObserver((mutationsList)=>{
            for (let mutation of mutationsList)if (mutation.type === 'childList' && mutation.addedNodes.length > 0) mutation.addedNodes.forEach((node)=>{
                if (node.tagName === 'IFRAME' && node.classList.contains('model-frame')) node.onload = function() {
                    node.contentWindow.document.addEventListener('click', checkModelsPagePermission, true);
                };
            });
        });
        observer.observe(main, {
            childList: true,
            subtree: true
        });
        checkModelsPagePermission();
        if (navWebEl) {
            navWebEl.classList.add('active');
            navWebEl.onclick = ()=>{};
        }
    }
    //  logout
    const logoutBtn = document.querySelector('.btn-logout');
    logoutBtn?.addEventListener('click', (e)=>{
        e.preventDefault();
        localStorage.removeItem('SCANAT_TOKEN');
        localStorage.removeItem('SCANAT_REFRESH_TOKEN');
        sessionStorage.removeItem('SCANAT_USER_INFO');
        localStorage.removeItem((0, $3CfG2.STORAGE_KEY).LOGIN_TIME);
        sessionStorage.removeItem('SCANAT_SHARE_KEY');
        sessionStorage.removeItem('customer');
        if (0, $iOF3G.userStore) (0, $iOF3G.userStore).clearUserData();
        window.location.href = '/login.html';
    });
    const key = (0, $h8sKa.isModelKey)();
    if (key) {
        if (!location.pathname.includes('models.html')) {
            location.href = `/models.html?${key}`;
            console.log('redirect to models');
        }
        return;
    }
    const dashboardBody = document.querySelector('.dashboard-body');
    const msg = "\u3053\u306E\u6A5F\u80FD\u306F\u307E\u3060\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u304C\u3001\u73FE\u5728\u30EA\u30EA\u30FC\u30B9\u306E\u6E96\u5099\u3092\u3057\u3066\u304A\u308A\u3001\u5C11\u3057\u304A\u5F85\u305F\u305B\u3057\u3066\u3057\u307E\u3046\u3053\u3068\u306B\u306A\u308A\u307E\u3059\u3002";
    if (location.pathname.includes('landing.html')) {
        const iconDashboardEl = document.querySelector('.landing-dashboard');
        if (iconDashboardEl) iconDashboardEl.onclick = async ()=>{
            const { isNoPortalAdmin: isNoPortalAdmin } = await (0, $h8sKa.checkAccountActive)();
            if (customerRes?.customerId && isNoPortalAdmin) {
                new (0, $6lxfX.default)().toast('warning', $acff720614031e27$var$t('error.contactManage'));
                return;
            }
            (0, $h8sKa.createAndClickAnchor)('/admin.html', '_blank');
        };
        const icon = document.querySelector('.landing-models');
        if (icon) icon.onclick = async ()=>{
            const accessResult = await (0, $h8sKa.checkCustomerAccess)();
            console.log(accessResult, 'accessResult');
            if (!accessResult.canAccess) {
                if (typeof accessResult.callback === 'function') {
                    accessResult.callback();
                    return;
                }
                new (0, $6lxfX.default)().toast('warning', accessResult.message, false, {
                    closeable: accessResult.closeable,
                    autohide: !accessResult.closeable
                });
                return;
            }
            (0, $h8sKa.createAndClickAnchor)('/models.html', '_blank');
        };
        dashboardBody?.classList.remove('d-none');
    }
    if (0, $h8sKa.isInDashboard) {
        const main = document.body.querySelector('main');
        const eventsToWatch = [
            'click'
        ];
        const checkDashboardPermission = async (e)=>{
            const { isNoPortalAdmin: isNoPortalAdmin } = await (0, $h8sKa.checkAccountActive)();
            if (customerRes?.customerId && isNoPortalAdmin) {
                e?.preventDefault();
                e?.stopPropagation();
                main.classList.add('d-none');
                document.body.innerHTML = '';
                const msg = $acff720614031e27$var$t('error.contactManage');
                new (0, $6lxfX.default)().toast('warning', msg, false, {
                    above: true,
                    callback: ()=>{
                        window.location.href = '/landing.html';
                    }
                });
                return;
            } else main.classList.remove('d-none');
        };
        eventsToWatch.forEach((eventName)=>{
            main.addEventListener(eventName, checkDashboardPermission, true);
        });
        checkDashboardPermission();
    }
    if (!isNoAuthPage && (0, $h8sKa.isInDashboard)) {
        // works for dashboard or other pages
        if (customerRes?.myDeptType === 2) {
            const sidebar = document.querySelector('#sidebarMenu');
            const ordersEl = sidebar?.querySelector('.sidebar-orders');
            const devicesEl = sidebar?.querySelector('.sidebar-devices');
            ordersEl?.classList.add('d-none');
            devicesEl?.classList.add('d-none');
        }
        dashboardBody?.classList.remove('d-none');
    }
    await (0, $k77ZD.default)();
    if (location.pathname.includes('rules.html')) {
        window.location.href = '/assets/files/rules.pdf';
        return;
    }
    const sidebar = document.querySelector('#sidebarMenu');
    // sidebar
    if (location.hash.includes('logs')) {
        const order = sidebar?.querySelector('.sidebar-logs');
        order?.classList.add('sidebar-active');
        if (navDashboardEl) {
            navDashboardEl.classList.add('active');
            navDashboardEl.onclick = ()=>{};
        }
    }
    if (location.hash.includes('dashboard')) {
        const order = sidebar?.querySelector('.sidebar-dashboard');
        order?.classList.add('sidebar-active');
        if (navDashboardEl) {
            navDashboardEl.classList.add('active');
            navDashboardEl.onclick = ()=>{};
        }
    }
    if (location.hash.includes('enterprise')) {
        const order = sidebar?.querySelector('.sidebar-enterprise');
        order?.classList.add('sidebar-active');
        if (navDashboardEl) {
            navDashboardEl.classList.add('active');
            navDashboardEl.onclick = ()=>{};
        }
    }
    if (location.hash.includes('orders') || location.hash.includes('payment')) {
        const order = sidebar?.querySelector('.sidebar-orders');
        order?.classList.add('sidebar-active');
        if (navDashboardEl) {
            navDashboardEl.classList.add('active');
            navDashboardEl.onclick = ()=>{};
        }
    }
    if (location.hash.includes('devices')) {
        const order = sidebar?.querySelector('.sidebar-devices');
        order?.classList.add('sidebar-active');
        if (navDashboardEl) {
            navDashboardEl.classList.add('active');
            navDashboardEl.onclick = ()=>{};
        }
    }
    // invitation
    if (location.hash.includes('invitation')) {
        const order = sidebar?.querySelector('.sidebar-invitation');
        order?.classList.add('sidebar-active');
        if (navDashboardEl) {
            navDashboardEl.classList.add('active');
            navDashboardEl.onclick = ()=>{};
        }
    }
    // navbar
    const navbar = document.querySelector('.navbar-nav');
    let currentActiveClass;
    switch(true){
        case location.pathname.includes('fee-plans.html'):
            currentActiveClass = '.nav-fee';
            break;
        case location.pathname.includes('introduction.html'):
            currentActiveClass = '.nav-intro';
            break;
        case location.pathname.includes('show-case.html'):
            currentActiveClass = '.nav-case';
            break;
        case location.pathname.includes('content-tab-5.html'):
        case location.pathname.includes('/articles/'):
        case location.pathname.includes('news.html'):
            currentActiveClass = '.nav-news';
            break;
        default:
            currentActiveClass = '.nav-home';
            break;
    }
    const currentActiveNav = navbar?.querySelector(currentActiveClass);
    currentActiveNav?.classList.add('active');
    // tooltip
    const downloadEl = document.querySelector('.download');
    if (downloadEl) {
        const tooltip = new mdb.Tooltip(downloadEl);
        tooltip._config.title = "\u3053\u306E\u30A2\u30D7\u30EA\u306FiOS\u306E\u307F\u5BFE\u5FDC\u3057\u3066\u304A\u308A\u307E\u3059\u3002";
        tooltip._config.placement = 'bottom';
        tooltip._config.customClass = 'tooltip-download';
    }
    const qrCodeEl = document.querySelector('.qrcode');
    if (qrCodeEl) new mdb.Tooltip(qrCodeEl, {
        title: 'qr code',
        html: true,
        placement: 'right',
        customClass: 'tooltip-qrcode',
        trigger: 'hover',
        template: `<div class="tooltip-qrcode" role="tooltip"><img src=${(0, (/*@__PURE__*/$parcel$interopDefault($lK1er)))} alt='qrcode'  /></div>`,
        container: qrCodeEl
    });
    const urlToken = location.search.split('?token=')?.[1];
    if (urlToken) localStorage.setItem('SCANAT_TOKEN', urlToken);
};
if ([
    'interactive',
    'complete'
].includes(document.readyState) && !window.isScanatLoaded) {
    $acff720614031e27$var$handleDomContentLoad();
    document.removeEventListener('DOMContentLoaded', $acff720614031e27$var$handleDomContentLoad);
} else document.addEventListener('DOMContentLoaded', $acff720614031e27$var$handleDomContentLoad);
if (!window.isDataLog) {
    window.isDataLog = true;
    (0, $dmrHV.initLogs)();
    (0, $dmrHV.initRum)();
}

});
parcelRegister("k77ZD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea4aa95861808676$export$2e2bcd8739ae039);

var $6lxfX = parcelRequire("6lxfX");

var $h8sKa = parcelRequire("h8sKa");

var $3CfG2 = parcelRequire("3CfG2");
const $ea4aa95861808676$var$beforePage = async ()=>{
    sessionStorage.removeItem((0, $3CfG2.STORAGE_KEY).REDIRECT_URL);
    const userInfo = JSON.parse(sessionStorage.getItem('SCANAT_USER_INFO')) ?? {};
    console.log('beforePage', userInfo);
    if (Object.keys(userInfo).length === 0) return;
    if (location.pathname.includes('models.html') && Object.keys(userInfo).length > 0) {
        let msg = '';
        const { isActive: isActive, isWebpermission: isWebpermission } = await (0, $h8sKa.checkAccountActive)();
        if (isActive === false) {
            msg = "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u7121\u52B9\u306E\u305F\u3081\u3001Scanat Web\u3092\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002";
            new (0, $6lxfX.default)().toast('warning', msg, false, {
                callback: ()=>{
                    window.location.href = '/landing.html';
                }
            });
        }
        if (!isWebpermission && !(0, $h8sKa.isModelKey)()) sessionStorage.setItem((0, $3CfG2.STORAGE_KEY).REDIRECT_URL, '/landing.html');
    }
};
var $ea4aa95861808676$export$2e2bcd8739ae039 = $ea4aa95861808676$var$beforePage;

});

parcelRegister("lK1er", function(module, exports) {
module.exports = import.meta.resolve("3Szto");

});

parcelRegister("iOF3G", function(module, exports) {

$parcel$export(module.exports, "userStore", () => $db2cbeddbe0f4376$export$e59f7e1dada53299);
$parcel$export(module.exports, "customerStore", () => $db2cbeddbe0f4376$export$299184113ba0c891);
$parcel$export(module.exports, "initUserStore", () => $db2cbeddbe0f4376$export$9645787f5e3040c1);
$parcel$export(module.exports, "getUserData", () => $db2cbeddbe0f4376$export$3f90b926bc531097);
$parcel$export(module.exports, "fetchUserData", () => $db2cbeddbe0f4376$export$1b2474068ca80b61);
$parcel$export(module.exports, "initCustomerStore", () => $db2cbeddbe0f4376$export$9c2520f7e88bf4af);
$parcel$export(module.exports, "fetchCustomerData", () => $db2cbeddbe0f4376$export$eb54390a7a7c3a41);

var $k6kKu = parcelRequire("k6kKu");

var $jPg91 = parcelRequire("jPg91");

var $28zQ1 = parcelRequire("28zQ1");

var $2tkaL = parcelRequire("2tkaL");
const $db2cbeddbe0f4376$export$d0dbd3788945df64 = (0, $jPg91.usePlanStore)((0, $k6kKu.default));
const $db2cbeddbe0f4376$export$e59f7e1dada53299 = (0, $28zQ1.useUserStore)((0, $k6kKu.default));
const $db2cbeddbe0f4376$export$299184113ba0c891 = (0, $2tkaL.useCustomerStore)((0, $k6kKu.default));
function $db2cbeddbe0f4376$export$5fff51638a9833be(planData) {
    if (planData) {
        $db2cbeddbe0f4376$export$d0dbd3788945df64.setPlanData(planData);
        return true;
    } else return false;
}
function $db2cbeddbe0f4376$export$95c0d5afc61844e5() {
    return $db2cbeddbe0f4376$export$d0dbd3788945df64.planData;
}
function $db2cbeddbe0f4376$export$9645787f5e3040c1(userData) {
    if (userData) {
        $db2cbeddbe0f4376$export$e59f7e1dada53299.setUserData(userData);
        return true;
    } else return false;
}
function $db2cbeddbe0f4376$export$3f90b926bc531097() {
    return $db2cbeddbe0f4376$export$e59f7e1dada53299.userData;
}
function $db2cbeddbe0f4376$export$1b2474068ca80b61() {
    return $db2cbeddbe0f4376$export$e59f7e1dada53299.fetchUserData();
}
function $db2cbeddbe0f4376$export$9c2520f7e88bf4af(customerData) {
    if (customerData) {
        $db2cbeddbe0f4376$export$299184113ba0c891.setCustomerData(customerData);
        return true;
    } else return false;
}
function $db2cbeddbe0f4376$export$7cbf1fa48900643() {
    return $db2cbeddbe0f4376$export$299184113ba0c891.customerData;
}
function $db2cbeddbe0f4376$export$eb54390a7a7c3a41() {
    return $db2cbeddbe0f4376$export$299184113ba0c891.fetchCustomerData();
}

});
parcelRegister("k6kKu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea24767b8d5f9966$export$2e2bcd8739ae039);

var $i0TKe = parcelRequire("i0TKe");
const $ea24767b8d5f9966$var$pinia = (0, $i0TKe.createPinia)();
var $ea24767b8d5f9966$export$2e2bcd8739ae039 = $ea24767b8d5f9966$var$pinia;

});

parcelRegister("jPg91", function(module, exports) {

$parcel$export(module.exports, "usePlanStore", () => $e6ef4db93d4fcd4f$export$a1dbd9a3c4c83da2);

var $i0TKe = parcelRequire("i0TKe");

var $6zHCj = parcelRequire("6zHCj");
const $e6ef4db93d4fcd4f$export$a1dbd9a3c4c83da2 = (0, $i0TKe.defineStore)('plan', {
    // 状态
    state: ()=>({
            planData: null
        }),
    // getters
    getters: {
        // 获取套餐信息
        getPlanData: (state)=>state.planData,
        // 判断是否有套餐
        hasPlan: (state)=>!!state.planData
    },
    // actions
    actions: {
        // 获取套餐信息
        async fetchPlanData () {
            this.loading = true;
            this.error = null;
            try {
                const res = await (0, $6zHCj.getCustomerPlanService)();
                if (res?.code === 200) this.planData = res.data;
            } catch (error) {
                console.error(error?.message);
            } finally{}
            return this.planData;
        },
        // 设置套餐数据（用于从外部直接设置数据）
        setPlanData (data) {
            this.planData = data;
        }
    }
});

});
parcelRegister("6zHCj", function(module, exports) {

$parcel$export(module.exports, "getPlanListService", () => $4c97d8613f2868ab$export$c39f30fa722f8af7);
$parcel$export(module.exports, "sumbitOrderService", () => $4c97d8613f2868ab$export$8cf4c408f5c2b7e8);
$parcel$export(module.exports, "getOrderListService", () => $4c97d8613f2868ab$export$e1dc08a939dfc8a0);
$parcel$export(module.exports, "getGoodsDetailService", () => $4c97d8613f2868ab$export$df8f206c0fc05a00);
$parcel$export(module.exports, "getOrderDetailService", () => $4c97d8613f2868ab$export$af4483d0b1f02980);
$parcel$export(module.exports, "getOrdersService", () => $4c97d8613f2868ab$export$cd5c22f1cfc57e47);
$parcel$export(module.exports, "getOrdersBriefService", () => $4c97d8613f2868ab$export$7170d101170881e0);
$parcel$export(module.exports, "cancelOrderService", () => $4c97d8613f2868ab$export$2ee448172253094e);
$parcel$export(module.exports, "getCreditCardsService", () => $4c97d8613f2868ab$export$915ef0f790adc010);
$parcel$export(module.exports, "setupIntentsService", () => $4c97d8613f2868ab$export$7b965068d977b64);
$parcel$export(module.exports, "addCreditCardService", () => $4c97d8613f2868ab$export$cff32dfed4a87ea8);
$parcel$export(module.exports, "cardPaymentService", () => $4c97d8613f2868ab$export$e529a0bcc4e3f4ba);
$parcel$export(module.exports, "invoicePaymentService", () => $4c97d8613f2868ab$export$cabcb850f167ed66);
$parcel$export(module.exports, "getCustomerInfoService", () => $4c97d8613f2868ab$export$2f8f526e9e9f791c);
$parcel$export(module.exports, "updateCustomerInfoService", () => $4c97d8613f2868ab$export$4cc4ee65ef05a6a6);
$parcel$export(module.exports, "addCustomerInfoService", () => $4c97d8613f2868ab$export$9de5ff65da61b4a4);
$parcel$export(module.exports, "getCustomerDomainsService", () => $4c97d8613f2868ab$export$2f783114dfddcca0);
$parcel$export(module.exports, "addCustomerDomainService", () => $4c97d8613f2868ab$export$259fc46d0823906b);
$parcel$export(module.exports, "removeCustomerDomainService", () => $4c97d8613f2868ab$export$91943afb8e022705);
$parcel$export(module.exports, "updateCustomerDomainService", () => $4c97d8613f2868ab$export$32820d76803615c3);
$parcel$export(module.exports, "expandSeatService", () => $4c97d8613f2868ab$export$f1fa2b0e8b9b341c);
$parcel$export(module.exports, "getOrderCardInfoService", () => $4c97d8613f2868ab$export$be4b0dba98e43c48);
$parcel$export(module.exports, "getCustomerPlanService", () => $4c97d8613f2868ab$export$6107c060db324eb9);
$parcel$export(module.exports, "getSeatAndModelService", () => $4c97d8613f2868ab$export$3566ceeb4b98be6);
$parcel$export(module.exports, "getRenewalFailuresService", () => $4c97d8613f2868ab$export$e1ecdee1e1d6cf23);
$parcel$export(module.exports, "getMembersService", () => $4c97d8613f2868ab$export$f0ef36cc5b25e05b);
$parcel$export(module.exports, "addMemberService", () => $4c97d8613f2868ab$export$7eadb3d08cef07f1);
$parcel$export(module.exports, "changeMemberRoleService", () => $4c97d8613f2868ab$export$b4e398f58d8b3714);
$parcel$export(module.exports, "updateMemberSeatService", () => $4c97d8613f2868ab$export$1d934ece6d69f804);
$parcel$export(module.exports, "enableMemberService", () => $4c97d8613f2868ab$export$6ee9e41cd7044f14);
$parcel$export(module.exports, "disableMemberService", () => $4c97d8613f2868ab$export$5bd4dec175275964);
$parcel$export(module.exports, "batchAddMembersService", () => $4c97d8613f2868ab$export$c21fc3e8ee98ad2b);
$parcel$export(module.exports, "removeMemberService", () => $4c97d8613f2868ab$export$6b76d2fbe1279195);
$parcel$export(module.exports, "batchRemoveMembersService", () => $4c97d8613f2868ab$export$8958cd7b42937956);
$parcel$export(module.exports, "activeMemberService", () => $4c97d8613f2868ab$export$32d5b860605561a0);
$parcel$export(module.exports, "updateMemberService", () => $4c97d8613f2868ab$export$2302d40615356011);
$parcel$export(module.exports, "exportMembersService", () => $4c97d8613f2868ab$export$d57beb5b165ebddd);
$parcel$export(module.exports, "updateDefaultCardService", () => $4c97d8613f2868ab$export$fb70897d21740e6f);
$parcel$export(module.exports, "getFundingInstructionsService", () => $4c97d8613f2868ab$export$92c209292289227c);
$parcel$export(module.exports, "resendInvoiceService", () => $4c97d8613f2868ab$export$40af73b5d614dfe2);
$parcel$export(module.exports, "getAddressByPostalCodeService", () => $4c97d8613f2868ab$export$57ef3af6e908c2c4);
$parcel$export(module.exports, "getCustomerPlanCancelInfoService", () => $4c97d8613f2868ab$export$e5971cfc56672ba7);

var $h8sKa = parcelRequire("h8sKa");
const $4c97d8613f2868ab$export$c39f30fa722f8af7 = ()=>{
    return (0, $h8sKa.request)('portal/plan/goods', {
        page: 1,
        size: 1000
    }, true, 'GET');
};
const $4c97d8613f2868ab$export$8cf4c408f5c2b7e8 = (data)=>{
    return (0, $h8sKa.request)('portal/order', data, true, 'PUT');
};
const $4c97d8613f2868ab$export$e1dc08a939dfc8a0 = (data)=>{
    return (0, $h8sKa.request)('portal/orders', data, true, 'GET');
};
const $4c97d8613f2868ab$export$df8f206c0fc05a00 = (id)=>{
    return (0, $h8sKa.request)(`portal/plan/goods/${id}`, null, true, 'GET');
};
const $4c97d8613f2868ab$export$af4483d0b1f02980 = (id)=>{
    return (0, $h8sKa.request)(`portal/orders/${id}`, null, true, 'GET');
};
const $4c97d8613f2868ab$export$cd5c22f1cfc57e47 = (params)=>{
    return (0, $h8sKa.request)('portal/orders', params, true, 'GET');
};
const $4c97d8613f2868ab$export$7170d101170881e0 = ()=>{
    return (0, $h8sKa.request)('portal/orders/brief', null, true, 'GET');
};
const $4c97d8613f2868ab$export$2ee448172253094e = (id)=>{
    return (0, $h8sKa.request)(`portal/orders/${id}/cancel`, null, true, 'POST');
};
const $4c97d8613f2868ab$export$915ef0f790adc010 = (params)=>{
    return (0, $h8sKa.request)('portal/cards', params, true, 'GET');
};
const $4c97d8613f2868ab$export$7b965068d977b64 = ()=>{
    return (0, $h8sKa.request)('portal/setupIntents', null, true, 'PUT');
};
const $4c97d8613f2868ab$export$cff32dfed4a87ea8 = (paymentMethodId, data)=>{
    return (0, $h8sKa.request)(`portal/cards/${paymentMethodId}`, data, true, 'PUT');
};
const $4c97d8613f2868ab$export$e529a0bcc4e3f4ba = (data)=>{
    return (0, $h8sKa.request)('portal/order/card/payment', data, true, 'POST');
};
const $4c97d8613f2868ab$export$cabcb850f167ed66 = (data)=>{
    return (0, $h8sKa.request)('portal/order/requestBook/payment', data, true, 'POST');
};
const $4c97d8613f2868ab$export$2f8f526e9e9f791c = ()=>{
    return (0, $h8sKa.request)('portal/customers', null, true, 'GET');
};
const $4c97d8613f2868ab$export$4cc4ee65ef05a6a6 = (data)=>{
    return (0, $h8sKa.request)('portal/customers', data, true, 'POST');
};
const $4c97d8613f2868ab$export$9de5ff65da61b4a4 = (data)=>{
    return (0, $h8sKa.request)('portal/customers', data, true, 'PUT');
};
const $4c97d8613f2868ab$export$2f783114dfddcca0 = async ()=>{
    try {
        const res = await (0, $h8sKa.request)('portal/customer/domain', null, true, 'GET');
        if (res?.code === 200 && Array.isArray(res.data)) return {
            success: true,
            data: res.data.map((item)=>({
                    id: item.id,
                    url: item.domain
                }))
        };
        return {
            success: false
        };
    } catch (error) {
        return {
            success: false
        };
    }
};
const $4c97d8613f2868ab$export$259fc46d0823906b = async (data)=>{
    try {
        const res = await (0, $h8sKa.request)('portal/customer/domain', {
            str: data?.url
        }, true, 'PUT');
        if (res?.code === 200) return {
            success: true
        };
        return {
            success: false,
            code: res.code
        };
    } catch (error) {
        return {
            success: false
        };
    }
};
const $4c97d8613f2868ab$export$91943afb8e022705 = async (data)=>{
    try {
        const res = await (0, $h8sKa.request)(`portal/customer/domain/${data?.id}`, data, true, 'DELETE');
        if (res?.code === 200) return {
            success: true
        };
        return {
            success: false
        };
    } catch (error) {
        return {
            success: false
        };
    }
};
const $4c97d8613f2868ab$export$32820d76803615c3 = async (data)=>{
    try {
        const res = await (0, $h8sKa.request)(`portal/customer/domain/${data?.id}`, {
            str: data?.url
        }, true, 'POST');
        if (res?.code === 200) return {
            success: true
        };
        return {
            success: false,
            code: res.code
        };
    } catch (error) {
        return {
            success: false
        };
    }
};
const $4c97d8613f2868ab$export$f1fa2b0e8b9b341c = (data)=>{
    return (0, $h8sKa.request)('portal/order/expand', data, true, 'POST');
};
const $4c97d8613f2868ab$export$594efd48dbc87dfa = (id)=>{
    return (0, $h8sKa.request)(`portal/orders/${id}/invoices`, null, true, 'GET', true);
};
const $4c97d8613f2868ab$export$c9811eede65bc11c = (id)=>{
    return (0, $h8sKa.request)(`portal/orders/${id}/requestBook`, null, true, 'GET', true);
};
const $4c97d8613f2868ab$export$be4b0dba98e43c48 = (id)=>{
    return (0, $h8sKa.request)(`portal/orders/${id}/card`, null, true, 'GET');
};
const $4c97d8613f2868ab$export$6107c060db324eb9 = ()=>{
    return (0, $h8sKa.request)('portal/customers/plan', null, true, 'GET');
};
const $4c97d8613f2868ab$export$3566ceeb4b98be6 = ()=>{
    return (0, $h8sKa.request)('portal/members/seatAndModel', null, true, 'GET');
};
const $4c97d8613f2868ab$export$e1ecdee1e1d6cf23 = ()=>{
    return (0, $h8sKa.request)('portal/customers/plan/renewal-failures', null, true, 'GET');
};
const $4c97d8613f2868ab$export$f0ef36cc5b25e05b = (data)=>{
    return (0, $h8sKa.request)('portal/members', data, true, 'GET');
};
const $4c97d8613f2868ab$export$7eadb3d08cef07f1 = (data)=>{
    return (0, $h8sKa.request)('portal/members', data, true, 'PUT');
};
const $4c97d8613f2868ab$export$b4e398f58d8b3714 = (data)=>{
    return (0, $h8sKa.request)('portal/members/changeRole', data, true, 'POST');
};
const $4c97d8613f2868ab$export$1d934ece6d69f804 = (data)=>{
    return (0, $h8sKa.request)('portal/members/useSeat', data, true, 'POST');
};
const $4c97d8613f2868ab$export$6ee9e41cd7044f14 = (userId)=>{
    return (0, $h8sKa.request)(`portal/members/${userId}/enable`, null, true, 'POST');
};
const $4c97d8613f2868ab$export$5bd4dec175275964 = (userId)=>{
    return (0, $h8sKa.request)(`portal/members/${userId}/disable`, null, true, 'POST');
};
const $4c97d8613f2868ab$export$c21fc3e8ee98ad2b = (formData)=>{
    return (0, $h8sKa.request)('portal/members/import', formData, true, 'POST');
};
const $4c97d8613f2868ab$export$6b76d2fbe1279195 = (id)=>{
    return (0, $h8sKa.request)(`portal/members/${id}`, null, true, 'DELETE');
};
const $4c97d8613f2868ab$export$8958cd7b42937956 = (data)=>{
    return (0, $h8sKa.request)('portal/members', data, true, 'DELETE');
};
const $4c97d8613f2868ab$export$32d5b860605561a0 = (id)=>{
    return (0, $h8sKa.request)(`portal/members/${id}/active`, null, true, 'PUT');
};
const $4c97d8613f2868ab$export$2302d40615356011 = (id, data)=>{
    return (0, $h8sKa.request)(`portal/members/${id}`, data, true, 'POST');
};
const $4c97d8613f2868ab$export$d57beb5b165ebddd = (params)=>{
    return (0, $h8sKa.request)('portal/members/export', params, true, 'GET', true);
};
const $4c97d8613f2868ab$export$a72845c7fb164829 = (id)=>{
    return (0, $h8sKa.request)(`portal/members/${id}/admin`, null, true, 'PUT');
};
const $4c97d8613f2868ab$export$46e0691aa336ad4f = (id)=>{
    return (0, $h8sKa.request)(`portal/members/${id}/admin`, null, true, 'DELETE');
};
const $4c97d8613f2868ab$export$163b3ae23bc4fe39 = ()=>{
    return (0, $h8sKa.request)('portal/members/import/template', null, true, 'GET', true);
};
const $4c97d8613f2868ab$export$fb70897d21740e6f = (paymentMethodId)=>{
    return (0, $h8sKa.request)(`portal/cards/${paymentMethodId}/default`, null, true, 'POST');
};
const $4c97d8613f2868ab$export$92c209292289227c = ()=>{
    return (0, $h8sKa.request)('portal/customers/fundingInstructions', null, true, 'GET');
};
const $4c97d8613f2868ab$export$40af73b5d614dfe2 = (data)=>{
    return (0, $h8sKa.request)('portal/order/requestBook', data, true, 'POST');
};
const $4c97d8613f2868ab$export$57ef3af6e908c2c4 = (postalCode)=>{
    return (0, $h8sKa.request)(`portal/postalCode/address?postalCode=${postalCode}`, null, true, 'GET', false);
};
const $4c97d8613f2868ab$export$e5971cfc56672ba7 = ()=>{
    return (0, $h8sKa.request)('portal/customers/plan/cancel', null, true, 'GET');
};

});


parcelRegister("2tkaL", function(module, exports) {

$parcel$export(module.exports, "useCustomerStore", () => $1ccdf014617ef454$export$d877bf4bbf8deefd);

var $i0TKe = parcelRequire("i0TKe");

var $h8sKa = parcelRequire("h8sKa");
const $1ccdf014617ef454$export$d877bf4bbf8deefd = (0, $i0TKe.defineStore)('customer', {
    state: ()=>({
            customerData: null
        }),
    getters: {
        getCustomerData: (state)=>state.customerData
    },
    actions: {
        async fetchCustomerData () {
            try {
                const res = await (0, $h8sKa.request)('portal/customers', null, true, 'GET');
                if (res?.data) {
                    this.customerData = res.data;
                    sessionStorage.setItem('customer', JSON.stringify(res.data));
                }
                return this.customerData;
            } catch (error) {
                console.error('Failed to fetch customer data:', error);
                return null;
            }
        },
        setCustomerData (data) {
            this.customerData = data;
            if (data) sessionStorage.setItem('customer', JSON.stringify(data));
        },
        clearCustomerData () {
            this.customerData = null;
            sessionStorage.removeItem('customer');
        }
    }
});

});


parcelRegister("64xtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $46bd157a62467627$export$2e2bcd8739ae039);
/**
 * 请求配置文件
 * 用于初始化请求管理器的白名单和其他配置
 */ 
var $364nM = parcelRequire("364nM");
const $46bd157a62467627$var$DEFAULT_WHITE_LIST = [
    'auth/currentUserInfo'
];
/**
 * 初始化请求配置
 */ const $46bd157a62467627$var$initRequestConfig = ()=>{
    (0, $364nM.setWhiteList)($46bd157a62467627$var$DEFAULT_WHITE_LIST);
};
var $46bd157a62467627$export$2e2bcd8739ae039 = $46bd157a62467627$var$initRequestConfig;

});



parcelRequire("eQRwW");

//# sourceMappingURL=ScanatWeb.5ca0d412.js.map
